/* 🤖 this file was generated by svg-to-ts */
export const matIconPublish: {
  name: 'publish';
  data: string;
} = {
  name: 'publish',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M5 4h14v2H5zm0 10h4v6h6v-6h4l-7-7-7 7zm8-2v6h-2v-6H9.83L12 9.83 14.17 12H13z"/></svg>`
};
